let EVENT = {}

EVENT.STATUS_CURRENT = 'current';
EVENT.STATUS_PAST    = 'past';

EVENT.TYPE_EVENT          = 10;
EVENT.TYPE_SESSION        = 20;
EVENT.TYPE_SESSION_TIME   = 30;
//----Old Events------------
EVENT.TYPE_EVENT_LEGACY   = 90;
EVENT.TYPE_SESSION_LEGACY = 100;

EVENT.TYPE_SINGLE_EVENT   = 10;
EVENT.TYPE_SINGLE_SESSION = 20;
EVENT.TYPE_MULTI_SESSION  = 30;

export default EVENT;